<template>
    <div v-if="items.length !== 0">
        <div class="orders">
            <h4 class="orders__label">Realizadas</h4>

            <ul class="orders__list">
                <li v-for="item in items" :key="item.id">

                    <div class="flex justify-between items-center">
                        <div class="flex-1 w-full">
                            <h4>{{ item.date }}</h4>
                            <p>{{ item.label_address }} - {{ item.price }}€</p>
                        </div>
                        <div class="flex items-center gap-x-2">
                            <button
                                class="btn--outlined--occurrence border-none"
                                @click="
                                    handleOccurrencesModal(
                                        item.id,
                                        item.store_id
                                    )
                                "
                            >
                                Obter ajuda
                            </button>
                            <div class="sm:hidden md:block">
                                <order-rating-modal v-if="!item.has_review" :order="item" />
                            </div>

                            <button
                                class="btn btn--outlined sm:hidden md:block"
                                @click="reorder(item.id)"
                            >
                                Reencomendar
                            </button>


                        </div>
                    </div>

                    <div class="sm:mt-10 orders__list-footer">
                        <ul>
                            <li
                                v-for="(listItem, index) in item.choices"
                                :key="index"
                            >
                                <h5 class="text-orange">
                                    {{ listItem.qty }} x
                                    {{ listItem.product_name }}
                                </h5>
                            </li>
                        </ul>
                    </div>

                    <div class="block md:hidden space-y-2">
                        <div>
                            <order-rating-modal v-if="!item.has_review" :order="item" />
                        </div>
                        <button
                            class="btn btn--outlined btn--full"
                            @click="reorder(item.id)"
                        >
                            Reencomendar
                        </button>

                    </div>
                </li>
            </ul>
        </div>

        <occurrences-modal
            v-if="showOccurenceModal"
            @cancel="showOccurenceModal = false"
            :storeId="storeId"
            :orderId="orderId"
            :externalClientId="externalClientId"
            :phoneCode="phoneCode"
            :phoneNumber="phoneNumber"
            :userName="userName"
        />
    </div>
</template>

<script>
import OccurrencesModal from "../modals/occurrences-modal.vue";
import OrderRatingModal from "../modals/order-rating-modal.vue";

export default {
    components: {
        OrderRatingModal,
        OccurrencesModal
    },
    props: {
        items: {
            required: true
        },
        externalClientId: {
            required: true
        },
        phoneCode: {
            required: true
        },
        phoneNumber: {
            required: true
        },
        userName: {
            required: true
        }
    },
    data() {
        return {
            showOccurenceModal: false,
            orderId: null,
            storeId: null
        };
    },
    mounted() {
    },
    methods: {
        reorder(id) {
            location = `/reorder/${id}`;
        },
        handleOccurrencesModal(orderId, storeId) {
            this.showOccurenceModal = true;
            this.orderId = orderId;
            this.storeId = storeId;
        }
    }
};
</script>
